/* ============================================================
   Sticky-навигация: добавляет класс .scrolled при прокрутке.
   ============================================================ */
import { byId } from '../dom';

export function initNav(): void {
  const nav = byId('nav');
  const onScroll = (): void => {
    nav.classList.toggle('scrolled', window.scrollY > 20);
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
}
